<template>
  <footer class="building_manage_footer">
    <div class="building_manage">
      <!-- footerleft -->
      <slot name="footerleft"></slot>
      <!-- footerright -->
      <div class="footerright">
        <div class="footer-btn">
          <BuildingButton :transparent="true" @click-btn="onClicnLeftBtn">
            <template #btnname>이전</template>
          </BuildingButton>
        </div>
        <div class="footer-btn">
          <BuildingButton :disabled="rightbtndisabled" @click-btn="onClickRightBtn">
            <template #btnname>다음</template>
          </BuildingButton>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import BuildingButton from '../BasicButton/BuildingButton.vue';
export default {
  props: {
    leftbtnfn: {
      type: Function,
      default: () => {},
      required: false
    },
    rightbtnfn: {
      type: Function,
      default: () => {},
      required: false
    },
    rightbtndisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    BuildingButton
  },
  methods: {
    onClicnLeftBtn() {
      this.leftbtnfn();
    },
    onClickRightBtn() {
      this.rightbtnfn();
    }
  }
};
</script>
<style scoped src="@/assets/css/building/buildingmanagefooter.css"></style>
